import React, { memo } from 'react';
import S from '../style/Dac7TabContent';
import Dac7Input from './Dac7Input';
import V from '../utils/validation';
import countries from '../utils/countriesList';
import { useI18n } from '../../../../../i18n';

interface Props {
  countryCodes: string[];
}

function sanitazeCountryCodes(codes: string[]) {
  const filteredCountryCodes = [] as string[];
  codes.forEach(countryCode => {
    if (countryCode !== '' && !filteredCountryCodes.includes(countryCode)) {
      filteredCountryCodes.push(countryCode);
    }
  });

  return filteredCountryCodes;
}

const Dac7Residencies = ({ countryCodes }: Props) => {
  const i18n = useI18n();
  const filteredCountryCodes = sanitazeCountryCodes(countryCodes);

  const countriesList = filteredCountryCodes.map(
    countryCode => countries.find(item => item.id === countryCode)?.label,
  );

  return (
    <>
      <S.Dac7Fieldset className="dac7-residencies">
        {countriesList.map((country, i) => (
          <S.Dac7FormField key={country}>
            <Dac7Input
              name={`dac7_residencies.${i}.countryCode`}
              label={`${i18n('dlv_dac7_residency_label')}${i === 0 ? '' : ` #${i + 1}`}`}
              pattern={V.getMinCharsPattern(2)}
              required
              value={country}
              disabled
            />
          </S.Dac7FormField>
        ))}
      </S.Dac7Fieldset>
      <S.StyledRequiredFieldsText>
        {i18n(`dlv_dac7_required_fields_description`)}
      </S.StyledRequiredFieldsText>
    </>
  );
};

export default memo(Dac7Residencies);
